import { Button, InputText, Select } from '@/components';
import { OptionProps } from '@/components/Select';
import { UseFormControl } from 'src/types';
import React from 'react';
import { FormInputNameCreditCard } from '../types';

interface AddCreditCardProps {
  state: boolean;
  controllerAddCreditCard: UseFormControl;
  onSubmit: () => void;
}

export const AddCreditCardContent: React.FC<AddCreditCardProps> = ({
  state,
  controllerAddCreditCard,
  onSubmit,
}) => {
  const month: OptionProps[] = [
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
  ];

  const year: OptionProps[] = [
    { value: '2026', label: '26' },
    { value: '2027', label: '27' },
    { value: '2028', label: '28' },
    { value: '2029', label: '29' },
    { value: '2030', label: '30' },
    { value: '2031', label: '31' },
    { value: '2032', label: '32' },
    { value: '2033', label: '33' },
    { value: '2034', label: '34' },
    { value: '2035', label: '35' },
    { value: '2036', label: '36' },
    { value: '2037', label: '37' },
    { value: '2038', label: '38' },
    { value: '2039', label: '39' },
    { value: '2040', label: '40' },
    { value: '2041', label: '41' },
    { value: '2042', label: '42' },
    { value: '2043', label: '43' },
    { value: '2044', label: '44' },
    { value: '2045', label: '45' },
    { value: '2046', label: '46' },
    { value: '2047', label: '47' },
    { value: '2048', label: '48' },
    { value: '2049', label: '49' },
    { value: '2050', label: '50' },
  ];
  return (
    <div className="w-full mt-[50px]">
      <div className="mb-[40px]">
        <InputText
          name="number"
          label="Número do cartão"
          placeholder="1234 5678 90123 3456"
          className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.number]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.number)(
              e.target.value,
            )
          }
          error={
            controllerAddCreditCard.formErrors.number &&
            controllerAddCreditCard.formErrors.number[0]
          }
        />
      </div>
      <div className="mb-[40px] grid grid-cols-2 gap-5">
        <Select
          name="state"
          label="Estado"
          placeholder="Selecione..."
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.month]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.month)(
              e?.target.value as string,
            )
          }
          className="col-span-2"
          error={
            controllerAddCreditCard.formErrors.state && controllerAddCreditCard.formErrors.state[0]
          }
          options={month}
        ></Select>
        <Select
          name="state"
          label="Estado"
          placeholder="Selecione..."
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.year]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.year)(
              e?.target.value as string,
            )
          }
          className="col-span-2"
          error={
            controllerAddCreditCard.formErrors.state && controllerAddCreditCard.formErrors.state[0]
          }
          options={year}
        ></Select>
        {/* <InputText
          name="date"
          label="Data de vencimento"
          placeholder="MM/AA"
          className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.date]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.date)(e.target.value)
          }
          maxLength={5}
          error={
            controllerAddCreditCard.formErrors.date && controllerAddCreditCard.formErrors.date[0]
          }
        /> */}
        <InputText
          name="cvv"
          label="CVV"
          placeholder="000"
          className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.cvv]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.cvv)(e.target.value)
          }
          error={
            controllerAddCreditCard.formErrors.cvv && controllerAddCreditCard.formErrors.cvv[0]
          }
        />
      </div>
      <div className="mb-[50px]">
        <InputText
          name="name"
          label="Nome do títular"
          placeholder="Maria da Silva"
          className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.name]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.name)(e.target.value)
          }
          error={
            controllerAddCreditCard.formErrors.name && controllerAddCreditCard.formErrors.name[0]
          }
        />
      </div>
      <div className="mb-[50px]">
        <InputText
          name="document"
          label="CPF do títular"
          placeholder="123.456.789-00"
          className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
          maxLength={14}
          value={controllerAddCreditCard.formData[FormInputNameCreditCard.document]}
          onChange={e =>
            controllerAddCreditCard.onChangeFormInput(FormInputNameCreditCard.document)(
              e.target.value,
            )
          }
          error={
            controllerAddCreditCard.formErrors.document &&
            controllerAddCreditCard.formErrors.document[0]
          }
        />
      </div>
      <div className="mb-[0px]">
        <Button
          type="submit"
          title="Adicionar cartão"
          buttonStyle="primary"
          size="xlg"
          className="w-full"
          disabled={
            state ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.number] === '' ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.month] === '' ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.year] === '' ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.cvv] === '' ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.name] === '' ||
            controllerAddCreditCard.formData[FormInputNameCreditCard.document] === ''
          }
          onClick={() => onSubmit()}
        />
      </div>
    </div>
  );
};
